import React from 'react';

export default function StepPanel({ lab }) {
  const biomarkers = lab.biomarkers || [];
  const displayPrice = lab.display_price ?? lab.price ?? 0;

  return (
    <div>
      {/* Panel card */}
      <div className="lcw-panel-card">

        {/* Category + name */}
        <div className="lcw-panel-top">
          {lab.image_url && (
            <img className="lcw-panel-image" src={lab.image_url} alt="" />
          )}
          <div>
            {lab.category && (
              <span className="lcw-panel-badge">{lab.category}</span>
            )}
            <div className="lcw-panel-name">{lab.name}</div>
          </div>
        </div>

        {/* Info grid — 2 columns, 2 rows */}
        <div className="lcw-panel-grid">
          <div className="lcw-panel-cell">
            <div className="lcw-panel-micro">Biomarkers</div>
            <div className="lcw-panel-value">{biomarkers.length} tests</div>
          </div>
          <div className="lcw-panel-cell lcw-panel-cell--right">
            <div className="lcw-panel-micro">Processing lab</div>
            <div className="lcw-panel-value">{lab.lab || '—'}</div>
          </div>
          <div className="lcw-panel-cell lcw-panel-cell--bottom">
            <div className="lcw-panel-micro">Sample</div>
            <div className="lcw-panel-value">
              {lab.sample || '—'}{lab.fasting === 'Required' ? ' - fasting' : ''}
            </div>
          </div>
          <div className="lcw-panel-cell lcw-panel-cell--bottom lcw-panel-cell--right">
            <div className="lcw-panel-micro">Results in</div>
            <div className="lcw-panel-value">{lab.turnaround || '—'}</div>
          </div>
        </div>

        {/* Biomarker pills */}
        {biomarkers.length > 0 && (
          <div className="lcw-panel-biomarkers">
            <div className="lcw-panel-micro lcw-panel-micro--spaced">
              What's measured · {biomarkers.length} biomarkers
            </div>
            <div className="lcw-panel-pills">
              {biomarkers.map((bm) => (
                <span key={bm} className="lcw-panel-pill">{bm}</span>
              ))}
            </div>
          </div>
        )}

        {/* Total due */}
        <div className="lcw-panel-total">
          <span className="lcw-panel-total-label">Total due</span>
          <span className="lcw-panel-total-amount">${displayPrice.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
}
